import { Text } from '@factorialco/deprecated-design-system'
import { F0Box, F0Icon, IconType } from '@factorialco/f0-react'

interface TitleProps {
  title: string
  icon: IconType
}
const Title = ({ title, icon }: TitleProps) => {
  return (
    <h2>
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="md">
        <F0Icon icon={icon} size="lg" color="secondary" />
        <Text.Header2>{title}</Text.Header2>
      </F0Box>
    </h2>
  )
}

export default Title
